module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-tab"
  }, [(_vm.comments.length) ? _c('div', {
    staticClass: "sc-list"
  }, _vm._l((_vm.comments), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "sc-item",
      class: {
        resolved: c.resolved
      }
    }, [_c('span', {
      staticClass: "sc-avatar",
      style: ({
        background: _vm.avatarColor(c.author)
      })
    }, [_vm._v(_vm._s(_vm.initials(c.author)))]), _vm._v(" "), _c('div', {
      staticClass: "sc-body"
    }, [_c('div', {
      staticClass: "sc-meta"
    }, [_c('span', {
      staticClass: "sc-author"
    }, [_vm._v(_vm._s(c.author))]), _vm._v(" "), _c('span', {
      staticClass: "sc-time"
    }, [_vm._v(_vm._s(_vm.relativeTime(c.createdAt)))])]), _vm._v(" "), _c('div', {
      staticClass: "sc-text"
    }, [_vm._v(_vm._s(c.text))]), _vm._v(" "), _c('button', {
      staticClass: "sc-resolve",
      class: {
        done: c.resolved
      },
      on: {
        "click": function($event) {
          return _vm.toggleResolved(c)
        }
      }
    }, [_c('span', {
      staticClass: "sc-resolve-dot"
    }), _vm._v("\n          " + _vm._s(c.resolved ? 'Resolved' : 'Mark resolved') + "\n        ")])])])
  }), 0) : _c('div', {
    staticClass: "sc-empty"
  }, [_vm._v("No comments yet on this stage.")]), _vm._v(" "), _c('div', {
    staticClass: "sc-compose"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft),
      expression: "draft"
    }],
    staticClass: "sc-input",
    attrs: {
      "rows": "3",
      "placeholder": "Add a comment about this stage..."
    },
    domProps: {
      "value": (_vm.draft)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.post.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.metaKey) { return null; }
        return _vm.post.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.draft = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-compose-actions"
  }, [_c('span', {
    staticClass: "sc-hint"
  }, [_vm._v("Ctrl/Cmd + Enter to post")]), _vm._v(" "), _c('button', {
    staticClass: "sc-post",
    attrs: {
      "disabled": !_vm.draft.trim()
    },
    on: {
      "click": _vm.post
    }
  }, [_vm._v("Post")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f963c3c4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/StageCommentsTab.vue
// module id = r7YS
// module chunks = 1